export const device = {
  currentFirmwareVersion: "当前固件版本：v{0}",
  firmwareUpgrade: "固件升级",
  firmwareVersion: "固件版本：v{0}",
  foundNewOTAPackage: "新的固件版本：v{0}",
  globalSettings: "全局设置",
  M3502PDName: "M350 - 2PD | M350 - 2PD + DSS",
  M3503PDName: "M350 - 3PD | M350 - 3PD",
  M350C100Name: "C100 | C100 AI 摄像头",
  M350C200Name: "C200 | C200 AI 摄像头",
  M3503PDDSSName: "M350 - 3PD + DSS | M350 - 3PD + DSS",
  M3504PDName: "M350 - 4PD | M350 - 4PD",
  R390Name: "R390",
  newVersionAvailable: "新的固件已发布",
  releaseNotes: "发布说明：",
  settingsWillAppliedToAllDevices: "这些设置将被应用于所有系统。",
  updateDeviceSettings: "更新系统设置",
  upgrade: "升级",
  upgradeFirmware: "升级固件",
  upgradeNow: "立刻升级",
  upgradeYourDevicesToVersion: "将您的系统升级到版本：{0}？",
  wouldUpdateToVehicleTips1: "在下面列出的设备中勾选您要更新设置的设备。",
  wouldUpdateToVehicleTips2:
    "(未勾选的设备将保持其当前的设置，将来您可以在其设备详情页面同步)",
  applyToVehicle: "应用到设备",
  saveSuccessfully: "保存成功，将在设备下一次启动时生效",
};
